export type UpdateError = (type: VALIDATIONS, invalid?: boolean) => void;

export interface EventUploadState {
  eventProfile: string;
  eventName: string;
  gopSeconds: number;
  uploadProgress: number;
  uploadTotal: number;
  analyzingLoaded: number;
  analyzingTotal: number;
  profileList: WebEventProfile[];
  errors: ValidationsObject;
  fileName: string;
  file: Blob | null;
  fileChecksum: string | null;
  fileChecksumProgress: number;
  isUploading: boolean;
  uploadCanceled: boolean;
  uploadFinished: boolean;
  signedUrlResponse: SignedUrlResponse | null;
  showFileRequirements: boolean;
  isAnalysisRunning: boolean;
  isChecksumTaskRunning: boolean;
}

export interface Action {
  type: ACTION_TYPE;
  payload: any;
}

export interface SignedUrlResponse {
  uploadUrl: string;
}

interface PersistentUrls {
  enabled: boolean;
  dashUrl: string;
  hlsUrl: string;
  dashUrlEnabled: boolean;
  hlsUrlEnabled: boolean;
}

export interface WebEventProfile {
  uuid: string;
  name: string;
  description: string;
  bucket: string;
  loadBalPrefix: string;
  deleteAfter: number;
  delaySeconds: number;
  persistentUrls: PersistentUrls;
  chromeCastAppId: string;
  regionId: string;
  branded: boolean;
  type: string;
  dvrWindowSeconds?: number;
}

export interface ValidationsObject {
  [key: string]: { message: string; invalid: boolean; key: string };
}

export enum ACTION_TYPE {
  PROFILE = 'PROFILE',
  NAME = 'NAME',
  UPLOAD_PROGRESS = 'UPLOAD_PROGRESS',
  UPLOAD_TOTAL = 'UPLOAD_TOTAL',
  ANALYZING_LOADED = 'ANALYZING_LOADED',
  ANALYZING_TOTAL = 'ANALYZING_TOTAL',
  FILE = 'FILE',
  FILE_CHECKSUM = 'FILE_CHECKSUM',
  FILE_CHECKSUM_PROGRESS = 'FILE_CHECKSUM_PROGRESS',
  FILE_NAME = 'FILE_NAME',
  PROFILE_LIST = 'PROFILE_LIST',
  ERROR_LIST = 'ERROR_LIST',
  IS_UPLOADING = 'IS_UPLOADING',
  UPLOAD_CANCELED = 'UPLOAD_CANCELED',
  UPLOAD_FINISHED = 'UPLOAD_FINISHED',
  SIGNED_URL_RES = 'SIGNED_URL_RES',
  GOP_SECONDS = 'GOP_SECONDS',
  SHOW_FILE_REQUIREMENTS = 'SHOW_FILE_REQUIREMENTS',
  SET_ANALYSIS_RUNNING = 'SET_ANALYSIS_RUNNING',
  SET_CHECKSUM_TASK_RUNNING = 'SET_CHECKSUM_TASK_RUNNING',
}

export enum VALIDATIONS {
  BACK_END = 'BACK_END',
  NETWORK_ERROR = 'NETWORK_ERROR',
  NOT_A_VIDEO = 'NOT_A_VIDEO',
  INVALID_FORMAT = 'INVALID_FORMAT',
  INVALID_FPS = 'INVALID_FPS',
  INVALID_DIMENSIONS = 'INVALID_DIMENSIONS',
  BLANK_EVENT_NAME = 'BLANK_EVENT_NAME',
  BLANK_EVENT_PROFILE = 'BLANK_EVENT_PROFILE',
  NO_UPLOAD_FILE = 'NO_UPLOAD_FILE',
  FILE_SIZE_0 = 'FILE_SIZE_0',
  INVALID_FILE_TYPE = 'INVALID_FILE_TYPE',
  INVALID_AUDIO_TYPE = 'INVALID_AUDIO_TYPE',
  MAX_DURATION = 'MAX_DURATION',
  MAX_FILE_SIZE = 'MAX_FILE_SIZE',
  MAX_AUDIO_CHANNELS = 'EXCEEDS_MAX_AUDIO_CHANNELS',
  MAX_AUDIO_BITRATE = 'EXCEEDS_MAX_AUDIO_BITRATE',
  MAX_VIDEO_CHANNELS = 'EXCEEDS_MAX_VIDEO_CHANNELS',
  MAX_VIDEO_BITRATE = 'EXCEEDS_MAX_VIDEO_BITRATE',
  MAX_RESOLUTION = 'MAX_RESOLUTION',
  MAX_GOP = 'MAX-GOP',
  INVALID_AUDIO_SAMPLERATE = 'INVALID_AUDIO_SAMPLERATE',
  NO_AUDIO = 'NO_AUDIO'
}

export enum CHECKSUM_MESSAGE {
  SUCCESS = 'success',
  ERROR = 'error',
  PROGRESS = 'progress'
}
